import {Colors} from './index'

// Message chat border style
export const messageInputBorder = {
  border: '1.5px solid',
  borderColor: Colors.rxrGreyColor,
}

// Form field border style
export const textfieldInputBorder = {
  border: '1px solid',
  borderColor: Colors.rxrPrimaryColor,
}

// Form field border style
export const textfieldInputBorderPrimary = {
  border: '1px solid',
  borderColor: Colors.rxrMidPrimary,
}
export const textfieldInputBorderTransparent = {
  border: '0px solid',
  borderColor: 'transparent',
}

export const borderRadiusMedium = '15px'
